import React from "react";
import R14, {
  View,
  StyleSheet,
  Image,
} from "../core";
import { commonStyles } from "../assets/css/commonStyle";
import Touchable from "./TouchableComponent";
import crateMessageIcon from "../assets/images/NewCreateMessage.png";

export default R14.connect(
  class AddMessageIconComponent extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
      };
    }

    goToCreateMessageScreen = () => {
      this.props.app.nav.to("addMessageScreenRoute");
    };

    render() {
      if(!!this.props.app.dm.userSession.state.isUberDocs) return null;
      return (
        <View style={[styles.headerControlsRight]}>
          <Touchable tooltip={'Add Message'} onPress={this.goToCreateMessageScreen}>
            <View>
                <Image source={crateMessageIcon} style={commonStyles.icon18} />
            </View>
          </Touchable>
        </View>
      );
    }
  }
);

const styles = StyleSheet.create({
  headerControlsRight: {
    paddingRight: 16,
    position: "relative",
  }
});
